import { createI18n } from 'vue-i18n'
import zhCN from './zh-CN'
import enUS from './en-US'

const locale = localStorage.getItem('locale') || 'zh-CN'

const i18n = createI18n({
  legacy: false,
  locale: locale,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

export default i18n
